import { useGetQuizzesQuery } from "@features/quizzes/quizzesApi";
import Quiz from "./Quiz";

const QuizList = () => {
  const { data: quizzes, isLoading, isError } = useGetQuizzesQuery();

  // decide what to render
  let content = "";

  if (isLoading) {
    content = <div className="text-center">Loading...</div>;
  }

  if (!isLoading && isError) {
    content = (
      <div className="text-center text-red-500">Internal server error!</div>
    );
  }

  if (!isLoading && !isError && quizzes?.length === 0) {
    content = <div className="text-center">No quizzes found!</div>;
  }

  if (!isLoading && !isError && quizzes?.length > 0) {
    content = (
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Question</th>
            <th className="table-th">Video</th>
            <th className="table-th">Action</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-600/50">
          {quizzes.map((quiz) => (
            <Quiz key={quiz.id} quiz={quiz} />
          ))}
        </tbody>
      </table>
    );
  }

  return <div className="overflow-x-auto mt-4">{content}</div>;
};

export default QuizList;
